<template>
  <div>
    <v-tabs
      fixed-tabs
      background-color="indigo"
      dark
      v-model="tab"
    >
      <v-tab key="0">
        vue-signature-pad
      </v-tab>
      <v-tab key="1">
        vue-barcode-scanner | QuaggaJS
      </v-tab>
      <v-tab key="2">
        vue-web-cam
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        :key="0"
      >
        <v-container fluid>
          <v-row class="justify-center">
            <h1>Sign in the square</h1>
          </v-row>

          <v-row class="justify-center align-center my-4">
              <VueSignaturePad
                id="signature"
                width="45vh"
                height="40vh"
                ref="signaturePad"
              />
          </v-row>

          <v-row class="justify-center">
            <div>
              <v-btn text color="grey" @click="clear">Clear</v-btn>
              <v-btn text color="blue" @click="save">Save</v-btn>
            </div>
          </v-row>

          <v-row v-show="imageSaved" class="justify-center">
            Signature PNG image Saved !
          </v-row>


        </v-container>


      </v-tab-item>

      <v-tab-item
        :key="1"
      >

        <v-container fluid>

          <v-row class="justify-center text-center">
            <v-col cols="12">
              <v-btn text large color="blue" @click="startScanning">{{isScanning ? 'Stop' : 'Scan'}}</v-btn>
              <v-quagga v-if="isScanning" :onDetected="excecute" :readerSize="readerSize"
                        :readerTypes="['ean_reader']"></v-quagga>
              <h2 v-if="isScanning" style="color:blue;">{{'detected code : ' + infos}}</h2>
            </v-col>

          </v-row>

        </v-container>

      </v-tab-item>


      <v-tab-item
        :key="2"
      >
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="6">
              <h2>Current Camera</h2>
              <code v-if="device">{{ device.label }}</code>
              <div class="border">
                <vue-web-cam
                  v-show="cameraPlaying"
                  ref="webcam"
                  :device-id="deviceId"
                  width="100%"
                  height="300"
                  @started="onStarted"
                  @stopped="onStopped"
                  @error="onError"
                  @cameras="onCameras"
                  @camera-change="onCameraChange"
                ></vue-web-cam>
              </div>

              <v-row>
                <v-col cols="12">
                  <v-select label="Select Device" v-model="camera" :items="devices">
                    <!--                    <option>&#45;&#45; Select Device &#45;&#45;</option>-->
                    <!--                    <option-->
                    <!--                      v-for="device in devices"-->
                    <!--                      :key="device.deviceId"-->
                    <!--                      :value="device.deviceId"-->
                    <!--                    >{{ device.label }}-->
                    <!--                    </option>-->
                  </v-select>
                </v-col>
                <v-col cols="12" style="text-align: center;flex-direction: column;display: flex;">
                  <v-btn v-show="cameraPlaying" text color="blue" @click="onCapture">Capture Photo</v-btn>
                  <v-btn v-show="cameraPlaying" text color="blue" @click="onStop;cameraPlaying = false;">Stop Camera
                  </v-btn>
                  <v-btn v-show="!cameraPlaying" text color="blue" @click="cameraPlaying = true;onStart">Start Camera
                  </v-btn>
                </v-col>
              </v-row>

            </v-col>
            <v-col cols="12" md="6">
              <h2>Captured Image</h2>
              <p v-if="!img" style="text-align: center;margin-top: 75px;">no pictures yet</p>
              <figure class="figure">
                <v-img v-if="img" :src="img" class="img-responsive"></v-img>
              </figure>
              <ul v-if="captures !== []" style="list-style-type: none;display: inline-flex;">
                <li v-for="c in captures">
                  <img :src="c" height="50"/>
                </li>
              </ul>

              <v-row v-if="img" class="justify-center">
                <v-btn text @click="saveImage" color="blue">Save last</v-btn>

                <div v-show="imageSaved2" class="justify-center">
                  Image Saved !
                </div>
              </v-row>

            </v-col>
          </v-row>
        </v-container>

      </v-tab-item>
    </v-tabs-items>


  </div>
</template>

<script>
    import VueBarcodeScanner from 'vue-barcode-scanner'
    import {WebCam} from "vue-web-cam";
    import VueSignaturePad from 'vue-signature-pad';
    import VueQuagga from 'vue-quaggajs';

    export default {
        name: "Demo.vue",
        components: {
            // StreamBarcodeReader,
            VueBarcodeScanner,
            "vue-web-cam": WebCam
        },
        data() {
            return {
                tab: null,
                loading: false,
                readerSize: {
                    width: 500,
                    height: 450
                },
                detecteds: [],
                isScanning: false,
                timer: '',
                infos: null,
                play: true,


                toCapture: null,
                img: null,
                camera: null,
                deviceId: null,
                devices: [],
                cameraPlaying: false,
                captures: [],
                imageSaved: false,
                imageSaved2: false,
            }

        },
        computed: {
            device: function () {
                return this.devices.find(n => n.deviceId === this.deviceId);
            }
        },
        watch: {
            camera: function (id) {
                this.deviceId = id;
            },
            devices: function () {
                // Once we have a list select the first one
                const [first, ...tail] = this.devices;
                if (first) {
                    this.camera = first.deviceId;
                    this.deviceId = first.deviceId;
                }
            }
        },
        methods: {
            onCapture() {
                this.img = this.$refs.webcam.capture();
                this.captures.push(this.img);
                console.log(this.img)
            },
            saveImage(){
                const link = document.createElement('a');
                link.href = this.img;
                link.setAttribute('download', 'portrait.jpeg');
                document.body.appendChild(link);
                link.click();

                this.imageSaved = true;

            },
            onStarted(stream) {
                console.log("On Started Event", stream);
            },
            onStopped(stream) {
                console.log("On Stopped Event", stream);
            },
            onStop() {
                this.$refs.webcam.stop();
            },
            onStart() {
                // this.cameraPlaying = true;
                this.$refs.webcam.start();
            },
            onError(error) {
                console.log("On Error Event", error);
            },
            onCameras(cameras) {
                this.devices = cameras;
                console.log("On Cameras Event", cameras);
            },
            onCameraChange(deviceId) {
                this.deviceId = deviceId;
                this.camera = deviceId;
                console.log("On Camera Change Event", deviceId);
            },



            excecute(data) {
                this.logIt(data);
                this.wait(4000);
            },

            logIt(data) {
                if (this.play) {
                    this.play = false;
                    console.log('detected', data);
                    this.infos = data.codeResult.code;
                }
            },
            wait(ms) {
                var start = new Date().getTime();
                var end = start;
                while (end < start + ms) {
                    end = new Date().getTime();
                }
                this.play = true;
            },
            startScanning() {
                this.isScanning = !this.isScanning;
            },



            clear() {
                this.$refs.signaturePad.clearSignature();
            },
            save() {
                var {isEmpty, data} = this.$refs.signaturePad.saveSignature();
                console.log(isEmpty);
                console.log(data);

                const link = document.createElement('a');
                link.href = data;
                link.setAttribute('download', 'signature.png');
                document.body.appendChild(link);
                link.click();

                this.imageSaved = true;
            }
        },

    }
</script>

<style scoped>

  >>> .viewport video[data-v-8d1d8f02] {
    left: 50%;
    width: 600px;
    margin: 75px 0 50px -300px;
  }

  >>> .viewport canvas[data-v-8d1d8f02] {
    position: absolute;
    left: 50%;
    width: 600px;
    margin: 75px 0 50px -300px;
  }

  @media only screen and (max-width: 700px) {

    >>> .viewport video[data-v-8d1d8f02] {
      left: 50%;
      width: 350px;
      margin: 75px 0 50px -175px;
    }

    >>> .viewport canvas[data-v-8d1d8f02] {
      position: absolute;
      left: 50%;
      width: 350px;
      margin: 75px 0 50px -175px;
    }
  }





  #signature {
    border: double 3px darkgrey;
    border-radius: 5px;
    background-image: linear-gradient(whitesmoke, whitesmoke),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Demo.vue